import { NOTIFICATION_IMPORTANT_COUNT } from "../constants";
import { SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import {
  IGetImportantResponseDto,
  INotificationDto,
  IRydeProcess,
} from "../models";

export class NotificationsApi {
  static async getNotifications(): Promise<INotificationDto[] | undefined> {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/notifications`;
    const response = await Api.get<INotificationDto[]>(requestUrl);

    return response?.data;
  }

  static async getCount(): Promise<number> {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/notifications/count`;
    const response = await Api.get<SimpleResult<number>>(requestUrl);

    return response?.data?.data ?? 0;
  }

  static async getImportant(): Promise<IGetImportantResponseDto | undefined> {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/notifications/important`;
    const response = await Api.get<SimpleResult<IGetImportantResponseDto>>(
      requestUrl,
      {
        take: NOTIFICATION_IMPORTANT_COUNT,
      },
    );

    return response?.data?.data;
  }

  static async bulkUpdateMarkAsRead(
    ids: number[],
  ): Promise<SimpleResult<IRydeProcess> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/notifications/bulk/update-as-read`;
    const response = await Api.patch<SimpleResult<IRydeProcess> | undefined>(
      requestUrl,
      {
        ids,
      },
    );

    return response?.data;
  }

  static async bulkUpdateResolved(
    ids: number[],
  ): Promise<SimpleResult<IRydeProcess> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/notifications/bulk/update-resolved`;
    const response = await Api.patch<SimpleResult<IRydeProcess> | undefined>(
      requestUrl,
      {
        ids,
      },
    );

    return response?.data;
  }
}
